export const USE_ELEMENT_WIDTH_RESIZE_KEYBOARD_STEP = 16

export const USE_ELEMENT_WIDTH_RESIZE_KEYBOARD_STEP_LARGE = 64
